<template>
  <access-request-listing />
</template>
<script>
import AccessRequestListing from '@/components/access-requests/AccessRequestListing.vue'
export default {
  name: 'AccessRequestsView',
  components: {
    AccessRequestListing
  }
}
</script>
<style lang="scss" scoped></style>
